export const validateEmail = (email: string | null): boolean => {
    if (!email) return false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
}
export const validatePhoneNumber = (phoneNumber: string): boolean => {
    const phoneNumberRegex =/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
    return phoneNumberRegex.test(phoneNumber);
}
export const validateName = (name: string) => {
    return Boolean(name) && name.trim().length > 0;
};

export const validatePersonName = (name: string): boolean => {
    const normalizedName = name?.trim().normalize('NFC');

    if (!normalizedName) return false;

    const allowedCharactersRegex = /^[\p{L}\p{M} .'-]+$/u;
    const validEdgeCharactersRegex = /^\p{L}(?:[\p{L}\p{M} .'-]*[\p{L}\p{M}])?$/u;

    if (!allowedCharactersRegex.test(normalizedName) || !validEdgeCharactersRegex.test(normalizedName)) {
        return false;
    }

    const characters = Array.from(normalizedName);
    const isLetterOrMark = (value: string | undefined) => Boolean(value && /^[\p{L}\p{M}]$/u.test(value));

    return characters.every((character, index) => {
        const previousCharacter = characters[index - 1];
        const nextCharacter = characters[index + 1];

        if (character === '-' || character === "'") {
            return isLetterOrMark(previousCharacter) && isLetterOrMark(nextCharacter);
        }

        if (character === '.') {
            return isLetterOrMark(previousCharacter) && (
                isLetterOrMark(nextCharacter) ||
                (nextCharacter === ' ' && isLetterOrMark(characters[index + 2]))
            );
        }

        if (character === ' ') {
            return previousCharacter !== ' ' && nextCharacter !== ' ' && nextCharacter !== undefined;
        }

        return true;
    });
};
